export default {"src":"/_next/static/media/TreeTwo.eeed2b1d.svg","height":219,"width":145,"blurWidth":0,"blurHeight":0};